export default {
      id: "battery-lvl-25-usage",
      viewBox: "0 0 22 14",
      url: __webpack_public_path__ + "img/icons.svg#battery-lvl-25",
      toString: function () {
        return this.url;
      }
    }